import { HTMLAttributes, PropsWithChildren } from 'react';
import { joinClassNames } from '../../utils';
import styles from './styles.module.scss';

export type ChipProps = PropsWithChildren<{ readonly active?: boolean }> &
  Pick<HTMLAttributes<never>, 'onClick' | 'className'>;

export const Chip = ({ active, onClick, className, children }: ChipProps) => (
  <button onClick={onClick} className={joinClassNames(styles.chip, className, active && styles.active)}>
    {children}
  </button>
);
